import { BlastworksClientEvent, ClientController } from 'client-controller';
import { FowlPurchaseSpinOrCollectState } from 'state-machine/states/fowl-purchase-spin-or-collect-state';

/**
 * Social purchase or collect state to send purchase state message
 *
 * @class SocialPurchaseSpinOrCollectState
 * @typedef {SocialPurchaseSpinOrCollectState}
 * @extends {PYLPurchaseSpinOrCollectState}
 */
export class SocialPurchaseSpinOrCollectState extends FowlPurchaseSpinOrCollectState {
  /**
   * Send purchase spin message
   *
   * @public
   * @override
   */
  public onEnter(): void {
    ClientController.getInstance().raiseEvent(BlastworksClientEvent.PURCHASE_SPIN);
    super.onEnter();
  }
}
